import styled from 'styled-components';

export const ScoringTypeBlock = styled.div`
  margin-right: 4rem;
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
`;
